import * as types from './actionTypes';
import * as API_END_POINTS from '../constants/api.js';
import axios from 'axios';
import queryString from 'query-string';
import { appBasePath } from '../constants/staticData';

export function signInUser(signInData, dispatch, fromSignup) {
  axios
    .post(API_END_POINTS.SIGNIN, JSON.stringify(signInData), {
      headers: {
        Accept: 'application/json,',
        'Content-Type': 'application/json'
      },
      withCredentials: true
    })
    .then(response => {
      if (response.status === 200) {
        let responseData = response.data.user;
        responseData['token'] = response.data.token;
        localStorage.setItem('businessAuthData', JSON.stringify(responseData));
        localStorage.setItem('businessUserId', JSON.stringify(responseData.id));
        localStorage.setItem('businessAccessToken', responseData.token);
        if (responseData.type === 'customer') {
          window.location.pathname = '/dashboard';
        } else {
          localStorage.setItem('garage_id', responseData.garageId);
          if (responseData.phone && !responseData.phoneVerified) {
            dispatch({
              type: types.SHOW_VERIFY_OTP_PAGE,
              fromSignIn: fromSignup ? false : true,
              authData: responseData
            });
          } else {
            let response = responseData;
            /*if(responseData.isEmergencyDriver) {
              response.isBusinessRegistered = true;
            }*/
            if (responseData.type === 'customer') {
              window.location.pathname = '/dashboard';
            } else {
              dispatch({
                type: responseData.isBusinessRegistered
                  ? types.SHOW_DASHBOARD
                  : responseData.isEmergencyDriver ? types.DRIVER_DASBOARD : types.SHOW_BUSINESS_DETAIL_REGISTRATION,
                authData: response
              });
            }
          }
        }
      } else {
        dispatch({
          type: types.SHOW_ERROR_MESSAGE,
          statusMessage: 'Unknown error occurred please try again'
        });
      }
    })
    .catch(err => {
      if (err.config) {
        if (err.response && err.response.status) {
          if (err.response.status === 401) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Email or Password is incorrect. Please try again.'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          }
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      }
    });
}
export function signInAction(signInData, dispatch, fromSignup) {
  if (fromSignup) {
    signInData.usertype = 'business';
    signInUser(signInData, dispatch, fromSignup);
  } else {
    return dispatch => {
      signInUser(signInData, dispatch);
    };
  }
}

export function socialAuth(accessToken, provider) {
  return dispatch => {
    const authPostData = {
      provider: provider,
      type: 'business',
      userType: 'business',
      accessToken: accessToken
    };
    axios
      .post(API_END_POINTS.SOCIAL_AUTH, JSON.stringify(authPostData), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status === 200) {
          let responseData = response.data.user;
          responseData['token'] = response.data.token;
          localStorage.setItem('businessAccessToken', responseData.token);
          localStorage.setItem('businessAuthData', JSON.stringify(responseData));
          localStorage.setItem('businessUserId', JSON.stringify(responseData.id));
          localStorage.setItem('garage_id', responseData.garageId);
          if (responseData.token) {
            axios.defaults.headers.common['x-access-token'] = responseData.token;
          }
          if (responseData.phone && !responseData.phoneVerified) {
            dispatch({
              type: types.SHOW_VERIFY_OTP_PAGE,
              authData: responseData
            });
          } else {
            if (responseData.type === 'customer') {
              window.location.pathname = '/dashboard';
            } else {
              dispatch({
                type: responseData.phone && responseData.phoneVerified
                  ? responseData.isBusinessRegistered ? types.SHOW_DASHBOARD : types.SHOW_BUSINESS_DETAIL_REGISTRATION
                  : types.SHOW_SEND_OTP_PAGE,
                authData: responseData
              });
            }
          }
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unable to authenticate, please try again'
          });
          dispatch({
            type: types.SAVE_LOG,
            appLog: 'Calling SignIn API ' + API_END_POINTS.SIGNIN + ' Login Success, Response:  ' + response.data
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (err && err.response && err.response.status) {
            if (err.response.status == 400 && provider == 'google') {
              const auth2 = window.gapi.auth2.getAuthInstance();
              if (auth2) {
                auth2.disconnect();
              }
            }
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function showVerifyOTPPage(signUpData) {
  return dispatch => {
    axios
      .post(API_END_POINTS.SIGNUP, queryString.stringify(signUpData), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/x-www-form-urlencoded'
        },
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200) {
          signInAction(
            {
              email: signUpData.email,
              password: signUpData.password
            },
            dispatch,
            true
          );
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (err.response && err.response.status) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function showWelcomePage(otp, phone, userId) {
  if (userId) {
    return dispatch => {
      axios
        .get(API_END_POINTS.VERIFY_OTP, {
          params: {
            type: 'phone',
            code: otp
          },
          headers: {
            Accept: 'application/json,',
            'Content-Type': 'application/json'
          },
          withCredentials: true
        })
        .then(response => {
          if (response.status === 200) {
            const authData = localStorage.getItem('businessAuthData')
              ? JSON.parse(localStorage.getItem('businessAuthData'))
              : {};
            authData.phoneVerified = true;
            localStorage.setItem('businessAuthData', JSON.stringify(authData));
            dispatch({
              type: types.SHOW_WELCOME_PAGE
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        })
        .catch(err => {
          if (err.config) {
            if (err.response && err.response.status) {
              dispatch({
                type: types.SHOW_ERROR_MESSAGE,
                statusMessage: err.response && err.response.data && err.response.data.message
                  ? err.response.data.message
                  : 'Unknown error occurred please try again'
              });
            } else {
              dispatch({
                type: types.SHOW_ERROR_MESSAGE,
                statusMessage: 'Unknown error occurred please try again'
              });
            }
          }
        });
    };
  } else {
    return dispatch => {
      dispatch({
        type: types.SHOW_WELCOME_PAGE
      });
    };
  }
}

export function hideErrorMessage() {
  return dispatch => {
    dispatch({
      type: types.HIDE_ERROR_MESSAGE
    });
  };
}

export function showErrorMessage(error) {
  return dispatch => {
    dispatch({
      type: types.SHOW_ERROR_MESSAGE,
      statusMessage: error
    });
  };
}

export function fetchCurrentUserInfo(router) {
  return dispatch => {
    axios
      .get(API_END_POINTS.CURRENT_USER_DETAILS, {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        },
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200) {
          const responseData = response.data;
          localStorage.setItem('businessAuthData', JSON.stringify(responseData));
          if (responseData.phone) {
            if (!responseData.phoneVerified) {
              dispatch({
                type: types.SHOW_VERIFY_OTP_PAGE,
                authData: responseData
              });
              router.push(`${appBasePath}/verify-otp`);
            }
          } else {
            dispatch({
              type: types.SHOW_SEND_OTP_PAGE,
              authData: responseData
            });
            router.push(`${appBasePath}/send-otp`);
          }
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      });
  };
}

export function resendOTP(phoneNumber, userTriggeredAPI) {
  return dispatch => {
    axios
      .post(API_END_POINTS.REQUEST_OTP, JSON.stringify({ phone: phoneNumber }), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        },
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200) {
          if (userTriggeredAPI) {
            window.alert('OTP has been send to ' + phoneNumber);
          }
          const authData = localStorage.getItem('businessAuthData')
            ? JSON.parse(localStorage.getItem('businessAuthData'))
            : '';
          dispatch({
            type: types.SHOW_VERIFY_OTP_PAGE,
            authData: authData
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: response.data && response.data.message
              ? response.data.message
              : 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: err && err.response && err.response.data && err.response.data.message
              ? err.response.data.message
              : 'Unknown error occurred please try again'
          });
        }
      });
  };
}

export function logout(router) {
  return dispatch => {
    axios
      .get(API_END_POINTS.LOGOUT, {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        },
        withCredentials: true
      })
      .then(() => {
        localStorage.clear();
        if (router) {
          router.push(`${appBasePath}/sign-in`);
        } else {
          window.location.pathname = `${appBasePath}/sign-in`;
        }
        dispatch({
          type: types.LOGOUT
        });
      })
      .catch(err => {
        if (err.config) {
          localStorage.clear();
          if (router) {
            router.push(`${appBasePath}/sign-in`);
          } else {
            window.location.pathname = `${appBasePath}/sign-in`;
          }
          dispatch({
            type: types.LOGOUT
          });
        }
      });
  };
}

export function registerBusinessProfile(profileData) {
  return dispatch => {
    // const formData = new FormData();
    // Object.keys(profileData).map((value) => {
    //   if (profileData[value]) {
    //     formData.append(value, profileData[value]);
    //   }
    // });
    axios
      .post(API_END_POINTS.BUSINESS_PROFILE_REGISTRATION + '?imageflow=1', profileData, {
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200) {
          const authData = localStorage.getItem('businessAuthData')
            ? JSON.parse(localStorage.getItem('businessAuthData'))
            : {};
          authData.isBusinessRegistered = true;
          authData.companyName = response.data.companyname;
          localStorage.setItem('businessAuthData', JSON.stringify(authData));
          dispatch({
            type: types.BUSINESS_PROFILE_REGISTRATION
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (
            err.response &&
            err.response.status &&
            (err.response.status === 400 || err.response.status === 401 || err.response.status === 403)
          ) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function forgotPassword(emailId) {
  return dispatch => {
    axios
      .post(API_END_POINTS.FORGOT_PASSWORD, JSON.stringify({ email: emailId }), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status == 200) {
          dispatch({
            type: types.SHOW_RESET_EMAIL_CONFIRMATION,
            email: emailId
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (err.response && err.response.status === 404) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: "User account doesn't exists!"
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function resetPassword(verificationCode, password) {
  return dispatch => {
    axios
      .post(API_END_POINTS.RESET_PASSWORD, JSON.stringify({ code: verificationCode, password: password }), {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status == 200) {
          dispatch({
            type: types.RESET_PASSWORD_CODE_VERIFIED
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Unknown error occurred please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (err.response && err.response.status) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function verifyEmail(code) {
  return dispatch => {
    axios
      .get(API_END_POINTS.VERIFY_EMAIL, {
        params: {
          type: 'email',
          code: code
        },
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        },
        withCredentials: true
      })
      .then(response => {
        if (response.status === 200) {
          dispatch({
            type: types.EMAIL_VERIFIED
          });
        } else {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: response.status === 401 || response.status === 410
              ? 'Wrong verification code'
              : 'Unable to verify email id, please try again'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          if (err.response && err.response.status) {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: err.response && err.response.data && err.response.data.message
                ? err.response.data.message
                : 'Unknown error occurred please try again'
            });
          } else {
            dispatch({
              type: types.SHOW_ERROR_MESSAGE,
              statusMessage: 'Unknown error occurred please try again'
            });
          }
        }
      });
  };
}

export function clearComponentKey() {
  return dispatch => {
    dispatch({
      type: types.CLEAR_COMPONENT_KEY
    });
  };
}

export function getAccountStatus() {
  return dispatch => {
    axios.get(API_END_POINTS.GET_ACCOUNT_STATUS).then(response => {
      if (response.status === 200) {
        dispatch({
          type: types.GET_ACCOUNT_STATUS,
          authData: response.data
        });
      }
    });
  };
}

export function autoAcceptJob(autoacceptjob) {
  return dispatch => {
    axios
      .post(API_END_POINTS.AUTO_ACCEPT_JOB, { autoacceptjob: autoacceptjob })
      .then(response => {
        if (response.data) {
          dispatch({
            type: types.AUTO_ACCEPT_JOB,
            autoacceptjob: autoacceptjob
          });
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: response.data.message,
            toastType: 'success'
          });
        } else {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: autoacceptjob
              ? 'Unable to enable auto accept quote, please try again'
              : 'Unable to disable auto accept quote, please try again',
            toastType: 'error'
          });
        }
      })
      .catch(err => {
        if (err.config) {
          dispatch({
            type: types.SHOW_TOAST_MESSAGE,
            toastMessage: autoacceptjob
              ? 'Unable to enable auto accept quote, please try again'
              : 'Unable to disable auto accept quote, please try again',
            toastType: 'error'
          });
        }
      });
  };
}

export function contactUs(ContactInfo) {
  return dispatch => {
    axios
      .post(API_END_POINTS.CONTACT_US, ContactInfo, {
        headers: {
          Accept: 'application/json,',
          'Content-Type': 'application/json'
        }
      })
      .then(response => {
        if (response.status == 200) {
          dispatch({
            type: types.SHOW_ERROR_MESSAGE,
            statusMessage: 'Message Sent succesfully'
          });
        }
      })
      .catch(err => {
        dispatch({
          type: types.SHOW_ERROR_MESSAGE,
          statusMessage: err.response && err.response.data && err.response.data.message
            ? err.response.data.message
            : 'Unknown error occurred please try again'
        });
      });
  };
}



// WEBPACK FOOTER //
// ./src/actions/authActions.js